var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.199,
    height: 72.79,
    viewBox: "0 0 193.199 72.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,18.373H6.444v12.1H19.2v-12.1h6.444V50.408H19.2V36.143H6.444V50.408H0V21.675a3.3,3.3,0,0,1,3.2-3.3",
    transform: "translate(0 4.685)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.584,49.025c-7.309-.225-10.951-4.479-10.951-12.681S26.333,24,33.694,23.957c7.683,0,11.291,4.7,10.836,14.168H28.881c.225,3.7,1.827,5.579,4.8,5.579a5.626,5.626,0,0,0,3.931-1.729,2.674,2.674,0,0,1,2.058-.87h4.479c-1.326,5.124-4.611,7.954-10.559,7.954M28.973,33.8h9.1c-.369-3.2-1.873-4.847-4.484-4.847S29.429,30.6,28.973,33.8",
    transform: "translate(5.771 6.109)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.961,30.608H41.886c.732-4.479,3.885-6.669,9.458-6.669,6.675,0,10.058,2.19,10.2,6.669v8.248c0,6.675-4.035,9.643-10.559,10.1-5.8.461-9.8-2.236-9.8-7.585.138-5.8,4.34-7.36,10.467-7.954,2.605-.317,3.931-1.1,3.931-2.421-.138-1.372-1.418-2.058-3.931-2.058-2.15,0-3.337.576-3.66,1.689m7.683,7.954V36.326a26.266,26.266,0,0,1-4.847,1.458c-2.421.461-3.654,1.6-3.654,3.383A2.712,2.712,0,0,0,50.232,44c3.383,0,5.441-2.012,5.441-5.441",
    transform: "translate(10.502 6.104)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.814,21.7V50.317H59.733V18.731h3.159A2.98,2.98,0,0,1,65.814,21.7",
    transform: "translate(15.232 4.776)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.042,30.022H73.4V43.988c0,1.009.576,1.562,1.787,1.562h1.885v4.611a33.4,33.4,0,0,1-6.427-.046c-2.306-.231-3.4-1.654-3.355-4.363V18.731h3.159a3.078,3.078,0,0,1,2.94,3.072v3.856h3.672V27a2.968,2.968,0,0,1-3.032,3.026",
    transform: "translate(17.159 4.776)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.088,30.7c-3.614,0-5.187,3.02-5.187,6.721V50.317H77.837V18.731H80.9c2.012,0,3.02,1.049,3.02,3.061v7.222c3.107-3.568,6.917-4.571,11.424-2.974q5.078,1.85,4.8,9.741V50.317H94.109V37.423c0-4.069-1.556-6.721-5.026-6.721",
    transform: "translate(19.849 4.776)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,41.273c0-1.5-.916-2.513-2.836-3.061-1.827-.576-3.931-1.1-6.167-1.689-6.081-1.556-9.1-4.392-9.1-8.507.138-6.53,4.035-9.735,11.706-9.689,7.314,0,11.107,3.2,11.47,9.649h-3.574a2.98,2.98,0,0,1-2.836-1.833c-1.049-1.781-2.928-2.651-5.626-2.651-3.291.046-4.934,1.28-5.072,3.66,0,1.965,1.965,3.383,6.035,4.294A72.953,72.953,0,0,1,117.7,33.6q5.187,1.781,4.934,7.677c-.363,6.081-4.479,9.1-12.34,9.1-8.225,0-12.387-3.424-12.571-10.191H103.9c.225,3.291,2.306,4.934,6.4,4.934s6.035-1.28,5.989-3.839",
    transform: "translate(24.92 4.673)",
    fill: "#fdb718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.664,38.782c0,4.156-1.049,6.917-3.2,8.225a14.029,14.029,0,0,1-7.13,1.879,12.208,12.208,0,0,1-6.859-2.058c-2.1-1.326-3.153-3.977-3.153-8.069V24.228H125.4V40c0,2.7,1.372,4.035,4.11,4.035s4.115-1.326,4.115-4.035V27.254c-.046-2.012.916-3.014,2.928-3.014h3.107Z",
    transform: "translate(30.427 6.178)",
    fill: "#fdb717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.025,48.942c-2.012-.133-3.014-1.1-3.014-3.014V33.039c-.138-2.519-1.51-3.752-4.208-3.752s-4.069,1.233-4.115,3.752v15.9H137.52V34.25c0-6.917,3.458-10.329,10.375-10.329s10.283,3.447,10.237,10.329V48.942Z",
    transform: "translate(35.068 6.1)",
    fill: "#fdb717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2,51.123v3.164H36.188V51.123h-2.34v8.456h2.34v-3.21H39.2v3.21h2.34V51.123Z",
    transform: "translate(8.631 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.134,51.123v8.456h6.859V57.585H44.451V56.242h4.058V54.4H44.451v-1.28h4.479V51.123Z",
    transform: "translate(10.744 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.569,51.077l-3.6,8.525h2.467l.576-1.51h3.262l.617,1.51h2.513l-3.6-8.513Zm1.112,2.761.945,2.4h-1.9Z",
    transform: "translate(12.488 13.025)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.125,51.123v8.456h6.432V57.527H60.466v-6.4Z",
    transform: "translate(14.822 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.678,51.123v2.052h2.53v6.4h2.346v-6.4H71.09V51.123Z",
    transform: "translate(16.238 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.711,51.123v3.164h-3V51.123H71.362v8.456h2.346v-3.21h3v3.21h2.346V51.123Z",
    transform: "translate(18.197 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.275,51.123h3.62c2.138,0,3.516,1.1,3.516,2.974h0c0,1.989-1.533,3.043-3.637,3.043H85.621v2.45h-2.34Zm3.458,4.2c.836,0,1.343-.432,1.343-1.1h0c0-.726-.507-1.112-1.355-1.112h-1.1v2.231Z",
    transform: "translate(21.235 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.711,51.123v8.456h6.438V57.527H93.057v-6.4Z",
    transform: "translate(23.131 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.659,51.077l-3.6,8.525h2.467l.576-1.51h3.262l.617,1.51h2.507l-3.6-8.513Zm1.112,2.778.945,2.4h-1.9Z",
    transform: "translate(24.751 13.025)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.877,51.123V55.59L108.4,51.123h-2.19v8.456h2.323v-4.64l3.608,4.64h2.052V51.123Z",
    transform: "translate(27.084 13.036)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.221,58.343l1.3-1.556a4.346,4.346,0,0,0,2.738,1.009c.628,0,.968-.213.968-.576h0c0-.352-.277-.542-1.424-.807-1.8-.415-3.187-.922-3.187-2.657h0c0-1.574,1.245-2.709,3.274-2.709a5.309,5.309,0,0,1,3.458,1.153L120.2,53.853a4.231,4.231,0,0,0-2.363-.83c-.576,0-.847.236-.847.542h0c0,.386.294.576,1.464.818,1.942.427,3.153,1.055,3.153,2.634h0c0,1.729-1.366,2.755-3.418,2.755a5.908,5.908,0,0,1-3.96-1.4",
    transform: "translate(29.126 13.016)",
    fill: "#003b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.859,6.423c13.776,0,25.857,6.513,32.7,16.3a34.9,34.9,0,0,0-65.414,0c6.847-9.8,18.934-16.3,32.71-16.3",
    transform: "translate(12.023 0)",
    fill: "#fdb717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.987,6.84l-2.306-.173A38.1,38.1,0,0,0,49.289,20.028l-.72.888c1.378-1.3,15.2-13.966,35.448-14.075",
    transform: "translate(12.385 1.664)",
    fill: "#fdb717"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2093b279485847008e20b625fbe87d85.svg";
export { ForwardRef as ReactComponent };